import React, { useState } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components/native';
import Colors from '../colors';
import Text from '../text';
const KeyPressable = styled.Pressable`
  height: 56px;
  width: 56px;
  border-radius: 28px;
  align-items: center;
  justify-content: center;
  background-color: ${_ref => {
  let {
    pressed
  } = _ref;
  return pressed ? Colors.lightGray200 : Colors.transparent;
}}
`;
export default function Key(_ref2) {
  let {
    disabled,
    onPress,
    children
  } = _ref2;
  const [pressed, setPressed] = useState(false);
  return /*#__PURE__*/React.createElement(KeyPressable, {
    disabled: disabled,
    pressed: pressed,
    onPressIn: () => setPressed(true),
    onPressOut: () => setPressed(false),
    onPress: onPress
  }, /*#__PURE__*/React.createElement(Text.H4, null, children));
}
Key.defaultProps = {
  disabled: false,
  onPress: () => null,
  children: ''
};
Key.propTypes = {
  disabled: PropTypes.bool,
  onPress: PropTypes.func,
  children: PropTypes.node
};
//# sourceMappingURL=key.js.map